<template>
    <div class="windows">
        <div class="container" style="margin-top: 20px;">
            <div v-if="this.$route.query.id" style="font-size: 20px; font-weight: 600; text-align: center; color: red;">这里是修改竞赛页面</div>
            <span style="margin-top:10px;">竞赛名称:</span>
            <el-input
                style="margin-top:10px;"
                placeholder="请输入竞赛名称"
                v-model="title"
                clearable>
            </el-input>
            <span style="margin-top:10px;">竞赛简介:</span>
            <el-input
                style="margin-top:10px;"
                type="textarea"
                :rows="10"
                placeholder="请输入竞赛详情"
                v-model="content">
            </el-input>

            <div style="margin-top:10px;">
                <span>竞赛开始时间: </span>
                <input type="datetime-local" v-model="selectedDateTime1">
                <p v-if="startTime">Selected Timestamp: {{ startTime }}</p>
            </div>
            
            <div style="margin-top:10px;">
                <span>竞赛结束时间: </span>
                <input type="datetime-local" v-model="selectedDateTime2">
                <p v-if="closeTime">Selected Timestamp: {{ closeTime }}</p>
            </div>

            <el-input
                style="margin-top:10px;"
                placeholder="请输入图片名称"
                v-model="imageName">
            </el-input>

            <span v-if="imageName"> 图片链接 {{ image }}</span>
            <h5 style="margin-top:10px;">上传竞赛图片</h5>
            <div>
              <input type="file" @change="handleFileUpload" accept="image/*" />
              <img v-if="imageUrl" :src="imageUrl" alt="Uploaded Image" style="max-width: 300px; margin-top: 20px;" />
              <p v-if="imageType">图片类型: {{ imageType }}</p>
              <button @click="uploadFile">上传到后端</button>
            </div>

            <div v-if="error_message" style="margin-top:10px; text-align:center; color:red; font-size:20px">{{ error_message }}</div>
            <el-button v-show="!this.$route.query.id" type="success" plain style="margin-top: 10px; margin-left:603px;" @click="ClickMeToSubmit">添加竞赛</el-button>
            <el-button v-show="this.$route.query.id" type="warning" plain style="margin-top: 10px; margin-left:603px;" @click="ClickMeToUpdate">修改竞赛</el-button>
        </div>
    </div>
</template>

<script>
    import Url from '@/constant/Url'
    import $ from "jquery"

    export default {
    name:'Programmes',
    data() {
        return {
            selectedDateTime1: null,
            selectedDateTime2: null,
            imageName:'',
            
            imageUrl: '',
            imageType: '',
            fileToUpload: null,
            photo:'',
            old_title:'',

            error_message:'',
            title:'萌新赛',
            startTime:null,
            closeTime:null,
            image:'',
            content:'    欢迎参加AL萌新赛，适合于希望提升算法能力拿到校招offer的同学、以及算法竞赛入门的选手。\n    比赛使用ACM赛制。难度和CF div3接近（可能有上下浮动）    \n    本场比赛时间为5小时，共6题。\n    \n    每道题目的罚时为AC时刻与比赛开始时刻所经过的时间。    通过题目的非AC提交每次罚时20分钟。\n    通过题目数相同时，总罚时短的同学排名靠前。\n    注意，因为每道题有调试模式，所以Compile Error也会计算罚时。\n\n    本场比赛过题选手，可以参与抽奖：\n    前50名抽1人，51-200名抽2人，201名之后每100人抽1名，赠送捶背棒~',
            time:'',
        }
    },
    watch: {
        selectedDateTime1: {
            deep:true,
            immediate:true,
            handler(selectedDateTime) {
                if (selectedDateTime) {
                    // 将选择的日期时间转换为时间戳（毫秒）
                    const selectedDate = new Date(selectedDateTime);
                    this.startTime = selectedDate.getTime();
                }
            }
        },
        selectedDateTime2: {
            deep:true,
            immediate:true,
            handler(selectedDateTime) {
                if (selectedDateTime) {
                    // 将选择的日期时间转换为时间戳（毫秒）
                    const selectedDate = new Date(selectedDateTime);
                    this.closeTime = selectedDate.getTime();
                }
            }
        }
    },
    mounted() {
        
        const query = this.$route.query
        if (query.id)
        {
            this.old_title = query.title,
            this.title = query.title,
            this.selectedDateTime1 = query.startTime
            this.selectedDateTime2 = query.closeTime
            this.imageName = query.image
            this.content = this.content
        }
    },
    methods: {
        ClickMeToUpdate() {
            const vue = this
            const route = this.$route
            const store = this.$store

            $.ajax({
                url: Url.uCompeteUrl,
                type:'post',
                headers: {
                    Authorization: "Bearer " + store.state.me.token,
                },
                data: {
                    id: route.query.id,
                    title: vue.title,
                    startTime: vue.startTime,
                    closeTime: vue.closeTime,
                    image: vue.image,
                    content: vue.content,
                },
                success(resp) {
                    vue.error_message = resp.error_message
                    console.log("old", vue.old_title)
                    console.log("new", vue.title)
                    if (vue.error_message === "success") {
                        $.ajax({
                            url: 'https://app6132.acapp.acwing.com.cn/jdg/competition/passrate/',
                            type: "post",
                            data: {
                                newcontent: vue.title,
                                content: vue.old_title,
                                event: 'reschedule',
                            }
                        })
                    }
                    
                },
                error(resp) {
                    console.log("修改竞赛彻底失败了， resp == >", resp)
                }
            })
        },
        ClickMeToSubmit() { // 添加竞赛
            const vue = this
            const store = this.$store
            
            console.log("image", this.image)
            $.ajax({
                url: Url.cCompeteUrl,
                type:'post',
                headers: {
                    Authorization: "Bearer " + store.state.me.token,
                },
                data: {
                    title: vue.title,
                    startTime: vue.startTime,
                    closeTime: vue.closeTime,
                    image: vue.image,
                    content: vue.content,
                },
                success(resp) {
                    vue.error_message = resp.error_message
                    vue.AddPassRate(vue.title)
                },
                error(resp) {
                    console.log("添加竞赛彻底失败了")
                }
            })
        },
        AddPassRate(title) {
            const vue = this
            const store = this.$store

            $.ajax({
                url: 'https://app6132.acapp.acwing.com.cn/jdg/competition/passrate/',
                type: "post",
                data: {
                    content: title,
                    event: 'create',
                }
            })
        },
        handleFileUpload(event) { // 看图片类型
          const file = event.target.files[0];
          
          const reader = new FileReader();

          reader.onload = (e) => {
            this.imageUrl = e.target.result; // 设置预览图像的URL
            // console.log("url == >", this.imageUrl)
            this.fileToUpload = file; // 将文件保存在组件数据中
            this.photo = file.name
            // 获取文件的扩展名
            const extension = file.name.split('.').pop().toLowerCase();
            // 获取文件的MIME类型
            const fileType = file.type;
            // console.log(file)
            console.log("extension", extension)
            this.image = "https://app6132.acapp.acwing.com.cn/static/image/" +  this.imageName + "." + extension
            // console.log("type", fileType)
            // 设置图片类型信息
            this.imageType = fileType;
          };

          if (file === null || file === undefined) {
            this.photo = ""
            this.imageUrl = ""
            this.imageType = ""
            
            console.log("没有图片捏")
            return
          }
          // 读取文件为DataURL
          reader.readAsDataURL(file);
        },
        uploadFile() { // 传给后端 使得图片有url
          if (!this.fileToUpload || this.imageName === "" || this.imageName === null) {
            console.error('没有选择文件 或者 没有输入图片名称');
            return;
          }

          // 创建一个FormData对象，将文件附加到其中
          const formData = new FormData();
          formData.append('image', this.fileToUpload);
          formData.append('userid', this.imageName)
          // 使用$.ajax发送文件到后端（假设上传的URL是/upload）
          $.ajax({
            url: 'https://app6132.acapp.acwing.com.cn/jdg/upload/classes/',
            method: 'POST',
            data: formData,
            processData: false,
            contentType: false,
            success: (response) => {
              console.log('文件上传成功');
              // 这里可以根据后端的响应进行相应处理
            },
            error: (error) => {
              console.error('发生错误:', error);
            }
          });
        },
    }
  }
</script>
 
<style scoped>
.windows {
  width: 100%; 
  min-height: 800px;
  height: auto;
}
</style>